module.exports = __webpack_public_path__ + "static/media/TapandPay.47c24560.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TapandPay.png
// module id = 6148
// module chunks = 1